export class ServiceQueryParameters {
  id?: string;
  name?: string;
  page?: number;
  pageSize?: number;

  constructor(obj?: ServiceQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
